import { Auth } from 'aws-amplify';

import config, { HAS_API_PROXY } from '../../config/env';
import { BASEURL } from '../endpoints';
import { AuthHeader, OrganizationIDHeader } from '../interfaces';
import { getAWSAmplifyRegion } from '@/api';
// import getOrganizationIdHeader from './getOrganizationIdHeader';

/* eslint-disable camelcase */
interface AmplifyAPIEndpointConfig {
    name: string;
    endpoint: string;
    region: string;
    custom_header?: () => Promise<Record<string, string>> | Record<string, string>;
}

const getAmplifyAPIEndpoints = (): AmplifyAPIEndpointConfig[] => {
    const endpoints: AmplifyAPIEndpointConfig[] = [
        {
            name: BASEURL.backend(),
            endpoint: config.API_URL,
            region: getAWSAmplifyRegion(config.cognito.IDENTITY_POOL_ID),
        },
        {
            name: BASEURL.localhost(),
            endpoint: 'https://localhost:3001',
            region: getAWSAmplifyRegion(config.cognito.IDENTITY_POOL_ID),
        },
    ];
    if (HAS_API_PROXY) {
        endpoints.push({
            name: BASEURL.backendProxy(),
            endpoint: config.API_PROXY.API_URL,
            region: getAWSAmplifyRegion(config.cognito.IDENTITY_POOL_ID),
            custom_header: async (): Promise<Partial<AuthHeader & OrganizationIDHeader>> => {
                try {
                    const session = await Auth.currentSession();
                    const token = session.getIdToken();
                    return {
                        Authorization: `Bearer ${token.getJwtToken()}`,
                        SpecterxUserId: token.payload.sub,
                    };
                } catch {
                    throw new Error('baseHeaders error');
                }
            },
        });
    }
    return endpoints;
};

export default getAmplifyAPIEndpoints;
